import Axios from "axios";
import { getPathName, retryRequest, getApiHash, getApiToken } from "./helper";

interface Telefono {
    CodigoArea: string;
    Numero: string;
    TelefonoEsCelular: boolean;
}

interface ActualizarEmision {
    idItemCotizacion: number | null;
    TipoDePersona: string | null;
    CondicionIVA: string | null;
    TipoUso: string | null;
    TieneGNC: boolean | null;
    Nombre: string | null;
    Apellido: string | null;
    Email: string | null;
    TipoDocumento: string | null;
    NroDocumento: string | null;
    Cuil: string | null;
    FechaNacimiento: string | null;
    Telefono: Telefono | null;
    TelefonoAdicional: Telefono | null;
    Provincia: string | null;
    Localidad: string | null;
    Calle: string | null;
    NumeroCalle: string | null;
    Piso: string | null;
    Departamento: string | null;
    CodigoPostal: string | null;
    Patente: string | null;
    NroMotor: string | null;
    NroChasis: string | null;
    NumeroTarjeta: string | null;
    MedioPago: string | null;
    TipoTarjetaCredito: string | null;
    BancoTarjetaCredito: string | null;
    NombreTitularTarjeta: string | null;
    ApellidoTitularTarjeta: string | null;
    MesVencimientoTarjeta: string | null;
    AnioVencimientoTarjeta: string | null;
}

type TypeStep = 0 | 1 | 2 | 3 | 4 | 5 | "F"; 


export const updateEmisionStep = async ( step: TypeStep, data: ActualizarEmision ) => {
   
    const params = {
        hash: await getApiHash(),
        step,
        actualizarEmision: {
            ...data
        }
    }

    const headers = {
        'content-type': 'application/json',
        "Authorization": 'Bearer ' + await getApiToken()
    }

    const axiosPostRequest = async() => {
        return Axios.post(await getPathName() + "/SetUpdateEmisionStep", params, {
            headers: headers
        });
    };

    try {
        const response = await retryRequest(axiosPostRequest);
        return response;
    } catch (error: any) {
        console.error('Fallo de hacer varios intentos: ' + error.message);
        return error;
    }
}